import { render, staticRenderFns } from "./accountReplyConfig.vue?vue&type=template&id=2104f3f4&scoped=true"
import script from "./accountReplyConfig.vue?vue&type=script&lang=js"
export * from "./accountReplyConfig.vue?vue&type=script&lang=js"
import style0 from "./accountReplyConfig.vue?vue&type=style&index=0&id=2104f3f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2104f3f4",
  null
  
)

export default component.exports